export const routes = [
  {
    path: "/",
    component: () => import("@/pages/App"),
    props: true,
    children: [
      {
        name: "list",
        path: "",
        components: {
          default: () => import("@/pages/Home"),
          footer: () => import("@/components/AppFooter"),
        },
      },
      {
        name: "list.embed",
        path: "embed",
        components: {
          default: () => import("@/pages/EmbedInline"),
        },
      },
      {
        name: "provider.embed",
        path: ":url/embed",
        props: true,
        component: () => import("@/pages/Embed"),
      },
      {
        name: "player.page",
        path: ":url/",
        props: {
          default: true,
          navigation: true,
        },
        components: {
          player_page: () => import("@/pages/Player"),
        },
      },
    ],
  },
];

export default routes;
